import type { UseListProps } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import { myOrderListQuery } from './graphql'
import type { Order } from '@ztechapps/common.contract'
import type { TabName } from './TabName'
import { useEffect, useState } from 'react'

export const useOrderList = (props: Partial<UseListProps<Order>> & { tabName: TabName }) => {
  const defaultSort = { createdAt: -1 as const }
  props.sort = props.sort ?? defaultSort

  const [count, setCount] = useState<number>(0)

  const orderList = useList<Order>({
    query: myOrderListQuery,
    ...props,
    options: {
      queryOptions: {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
      },
    },
  })

  useEffect(() => {
    setCount(orderList?.pageInfo?.count ?? 0)
  }, [props.tabName, orderList?.pageInfo?.count, orderList.loading, orderList.networkStatus])

  return { orderList, count }
}
